<ng-template #uploadButtons>
  <nz-space>
    <!-- <a *nzSpaceItem nz-button (click)="fileUploadInput.click()" nzType="primary">
      <i class="fal fa-photo-video"></i>&nbsp;&nbsp; Add from library
    </a> -->
      
    <nz-button-group *nzSpaceItem>
    
      <a nz-button (click)="fileUploadInput.click()" nzType="default">
        <i class="fa-light fa-upload"></i>&nbsp;&nbsp; {{'Upload' | translate}}
      </a>
      <a nz-button (click)="uploadLink()" nzType="default">
        <i class="fa-light fa-link"></i>&nbsp;&nbsp; {{'Link' | translate}}
      </a>
    </nz-button-group>
  </nz-space>
</ng-template>
<nz-space nzDirection="vertical" style="width: 100%">
  <div *nzSpaceItem style="text-align: right">
    
    <ng-container
      *ngIf="
        (imagesMedia != null && imagesMedia.length > 0) ||
        (filesMedia != null && filesMedia.length > 0)
      "
      [ngTemplateOutlet]="uploadButtons"
    >
    </ng-container>
  </div>
  <ng-container *nzSpaceItem>
    <nz-empty
      *ngIf="
        !(imagesMedia != null && imagesMedia.length > 0) &&
        !(filesMedia != null && filesMedia.length > 0)
      "
      [nzNotFoundFooter]="uploadButtons"
    >
    </nz-empty>
    <ng-container
      *ngIf="imagesMedia != null && imagesMedia.length > 0"
      [ngTemplateOutlet]="imagesTemplate"
    ></ng-container>
    <ng-container
      *ngIf="filesMedia != null && filesMedia.length > 0"
      [ngTemplateOutlet]="filesTemplate"
    ></ng-container>
    
  </ng-container>
</nz-space>

<ng-template #imagesTemplate>
  <nz-table
    #imagesTable
    [nzData]="imagesMedia"
    nzBordered
    [nzShowPagination]="false"
  >
    <thead></thead>
    <tbody>
      <ng-container *ngFor="let item of imagesMedia;trackBy: trackByFn">
        <tr
          app-media
          *ngIf="item.isCover !== true"
          [mediaStructure]="item"
          (preview)="parentPreview($event)"
          (download)="fileDownload($event)"
          (remove)="removeFile($event)"
          (RoleChanges)="ChangeRole($event)"
        ></tr>
      </ng-container>
    </tbody>
  </nz-table>
</ng-template>
<ng-template #filesTemplate>
  <nz-table
    #filesTable
    [nzData]="filesMedia"
    nzBordered
    [nzShowPagination]="false"
  >
    <thead></thead>
    <tbody>
      <ng-container *ngFor="let item of filesMedia">
        <tr
          app-media
          [mediaStructure]="item"
          (preview)="parentPreview($event)"
          (download)="fileDownload($event)"
          (remove)="removeFile($event)"
        ></tr>
      </ng-container>
    </tbody>
  </nz-table>
</ng-template>

<input
  #fileUploadInput
  type="file"
  id="input-file"
  nz-input
  multiple
  style="display: none"
  accept="image/*,video/*"
  (change)="handleFileInput($event)"
/>

<nz-divider></nz-divider>

<nz-drawer
  [nzWrapClassName]="'drawer-size-3x'"
  [nzTitle]="'Link Media'"
  [nzVisible]="drawerVisible"
  [nzFooter]="drawerLinkFooter"
  (nzOnClose)="onLinkDrawerClose()"
  [nzWidth]="'650px'"
>
  <ng-container *nzDrawerContent>
    <nz-form-item>
      <nz-form-label [nzSpan]="6">{{'Link Type' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <nz-radio-group [(ngModel)]="linkType">
          <label nz-radio-button nzValue="I">
            <i class="fal fa-image"></i>&nbsp;&nbsp;{{'Image' | translate}}
          </label>
          <label nz-radio-button nzValue="V">
            <i class="fal fa-video"></i>&nbsp;&nbsp;{{'Video' | translate}}
          </label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="6">{{'Url' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <input nz-input [(ngModel)]="mediaLink" (blur)="getYouTubeInfo()" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="6">{{'Title' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <input nz-input [(ngModel)]="linkTitle" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="6">{{'Description' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <textarea
          nz-input
          [nzAutosize]="{ minRows: 5, maxRows: 10 }"
        ></textarea>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="6">{{'Role' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <nz-select
          nzMode="multiple"
          [nzPlaceHolder]="'Please select roles' | translate"
          nzSize="default"
          style="width: 100%"
          [(ngModel)]="linkRols"
        >
          <nz-option nzLabel="Base" nzValue="1"></nz-option>
          <nz-option nzLabel="Small" nzValue="2"></nz-option>
          <nz-option nzLabel="Thumbnail" nzValue="3"></nz-option>
          <nz-option nzLabel="Swatch" nzValue="4"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="linkType === 'V'">
      <nz-form-label [nzSpan]="6">{{'Cover Image' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <input
          type="file"
          id="input-file"
          nz-input
          (change)="handleCoverFileInput($event)"
          accept="image/*"
        />
        <br *ngIf="covertUrl !== null" />
        <img
          *ngIf="covertUrl !== null"
          nz-image
          [src]="covertUrl | safeHtml : 'resourceUrl'"
          style="max-width: 100%; max-height: 250px"
          [nzFallback]="'/assets/bad-image.png'"
        />
       
      </nz-form-control>
    </nz-form-item>
    <ng-container *ngIf="linkType === 'I'">
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> {{'Preview' | translate}} </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <img
            nz-image
            [src]="mediaLink | safeHtml : 'url'"
            [nzFallback]="'/assets/bad-image.png'"
            style="max-width: 100%; max-height: 250px"
          />
    
         
        </nz-form-control>
      </nz-form-item>
    </ng-container>
    <ng-container *ngIf="linkType === 'V' && mediaLink != null">
      <nz-form-item>
        <nz-form-label [nzSpan]="6"> {{'Video' | translate}} </nz-form-label>
        <nz-form-control [nzSpan]="18">
          <iframe
            *ngIf="linkType === 'V'"
            style="max-width: 100%; max-height: 250px"
            [src]="mediaLink | safeHtml : 'resourceUrl'"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </nz-form-control>
      </nz-form-item>
    </ng-container>
  </ng-container>
</nz-drawer>
<ng-template #drawerLinkFooter>
  <nz-space>
    <a *nzSpaceItem nz-button nzType="primary" (click)="handleLinkInput()">
      <i class="fa-light fa-floppy-disk"></i>&nbsp;&nbsp; {{'Save' | translate}}
    </a>
    <a
      *nzSpaceItem
      nz-button
      nzType="default"
      nzDanger
      (click)="onLinkDrawerClose()"
    >
      <i class="fal fa-window-close"></i>&nbsp;&nbsp; {{'Cancel' | translate}}
    </a>
  </nz-space>
</ng-template>
